









import {defineComponent, PropType} from '@vue/composition-api'

import linksDirective from '@/shared/directives/links-directive'

export default defineComponent({
    name: "RichTextAtom",
    directives: {
        linksDirective
    },
    props: {
        paragraphs: {
            type: Array as PropType<String[]>,
            required: true
        }
    }
})
